import { useEffect, useRef } from "react";

import { ForEach } from "@components/control-statements";
import { useIsInViewport } from "@hooks";

import { Loading } from "@components";
import styles from "@styles/pages/cdp/customers.module.scss";
import { If } from "shared/components/control-statements";
import { Customer } from "./Customer";

import classNames from "classnames/bind";
const css = classNames.bind(styles);

export const Customers = ({
  customers,
  onSelectCustomer,
  onLoadMoreData,
  loading,
  audience,
  hasNext = true,
}) => {
  const table_end_ref = useRef(null);
  const is_visible = useIsInViewport(table_end_ref);

  useEffect(() => {
    const load = async () => {
      onLoadMoreData && (await onLoadMoreData());
    };

    is_visible && hasNext && load();
  }, [is_visible, onLoadMoreData]);

  return (
    <>
      <div className={styles.table}>
        <table>
          <thead>
            <tr>
              <th>Identificação</th>
              <If cond={audience?.version !== "V1"}>
                <th>Perfil RFV</th>
              </If>
              <th>Total gasto</th>
              <th>Pedidos</th>
            </tr>
          </thead>
          <tbody>
            <ForEach
              items={customers}
              render={(customer) => (
                <Customer
                  customer={customer}
                  onSelectCustomer={(customer) => {
                    // console.log(customer);
                    onSelectCustomer?.(customer);
                  }}
                  audience={audience}
                />
              )}
            />
          </tbody>
        </table>
      </div>

      <If cond={loading}>
        <div className={styles.loading}>
          <div className="w-100 d-flex align-center justify-center flex-1 mt-30 pb-25">
            <Loading />
          </div>
        </div>
      </If>
      <div ref={table_end_ref}>&nbsp;</div>
    </>
  );
};
